const initRefactoHeader = () => {
	const header = document.querySelector('.header');
	const search = header.querySelector('.header__search');
	const account = header.querySelector('.header__account');
	search.insertAdjacentElement('beforebegin', account);
};

/**
 * @description gère le sticky menu
 */

const stickyMenu = () => {
	const header = document.querySelector('.header');
	document.onscroll = () => {
		window.pageYOffset > 40
			? header.classList.add('header--scrolled')
			: header.classList.remove('header--scrolled');
	};
};

const accountG1 = () => {
	const account = document.querySelector('[data-header-account]');
	const w = window.innerWidth;
	if (account) {
		const btn = document.querySelector('[data-js-header-account-toggle]');
		const txt = account.querySelector('.btn-text');
		const agentName = txt.querySelector('.agent-name');
		account.addEventListener('click', (e) => {
			if (e.target === txt || (agentName && e.target === agentName))
				btn.click();
		});
		const content = account.querySelector('.header__account--content') || null;
		if(content){
			w < 650
			? content.insertAdjacentElement('afterbegin', txt)
			: btn.insertAdjacentElement('afterend', txt);
		}
	}
};
window.addEventListener('load', function () {
	initRefactoHeader();
	accountG1();
	stickyMenu();
});
window.addEventListener('resize', () => {
	accountG1();
});
